import { Input } from 'antd';
import { observer } from 'mobx-react-lite';

const CustomInput = observer(
    ({ value, onChange, className, placeholder, maxLength, disabled }) => {
        return (
            <Input
                // variant="borderless"
                disabled={disabled}
                value={value}
                onChange={onChange}
                className={`custom-input w-full bg-theme-transparent border-[1px] border-theme-stroke h-[40px] rounded-[8px] px-[16px] text-[14px] font-[400] ${className}`}
                placeholder={placeholder}
                maxLength={maxLength}
            />
        );
    },
);

export default CustomInput;
